module.exports = __webpack_public_path__ + "static/img/img_2289.b278059.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_2289.jpg
// module id = 9l7p
// module chunks = 0